import { styled } from "styled-components";

export const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 1000px;
  align-items: center;
`;
